import {memoize} from '@servicenow/ui-utils';

export default function memoizeProfiler(func, options = {}) {
	const {createCacheKey, profileName} = options;
	return memoize(func, createCacheKey || (arg1 => arg1), {profileName});
}
